/**
 * Migration : convertit une customDescription legacy en ProductBrief
 * Met le texte existant dans freeformNotes pour ne rien perdre
 */

import { createEmptyProductBrief } from "../types/productBrief";
import type { ProductBrief } from "../types/productBrief";

export function customDescriptionToProductBrief(description: string | null | undefined): ProductBrief | null {
  if (!description || typeof description !== "string" || !description.trim()) return null;

  const brief = createEmptyProductBrief();
  brief.freeformNotes = description.trim();
  return brief;
}
